import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { User } from '../user/User'
import { RelatedEntity } from '../base/RelatedEntity'

import { Entity } from '../base/Entity'

@ObjectType()
@InputType('ActivityInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Activity extends Entity {
  @Field(() => String)
  @Prop({ type: String })
  activity?: string

  @Field(() => User)
  @Prop({ type: RelatedEntity })
  by?: User

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  isDeleted?: boolean
}
